import { ArrowUp, Mail } from "lucide-react";
import { CONTACT_EMAIL } from "@/constants/contact";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#24283b] bg-[#07080b] py-12 px-6 lg:px-12 text-neutral-500 font-mono-goat text-xs"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-3">
          <img src="/goat-logo.jpg" alt="GOAT Productions" className="h-10" />
          <span>•</span>
          <span>All Rights Reserved</span>
        </div>
        <div className="flex gap-6 items-center">
          <span>Nationwide Delivery • Remote Studio</span>
          {CONTACT_EMAIL && (
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email-link"
              className="inline-flex items-center gap-1 hover:text-white transition-colors"
            >
              <Mail className="w-3.5 h-3.5" /> {CONTACT_EMAIL}
            </a>
          )}
          <a
            href="#top"
            data-testid="back-to-top-link"
            className="inline-flex items-center gap-1 hover:text-white transition-colors"
          >
            <ArrowUp className="w-3.5 h-3.5" /> Back to Top
          </a>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="hover:text-[#45f3ff] transition-colors"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
